<template>
    <div class="base-message" :class="{'message-sp': $store.state.screen == 1}">
        <div class="header">
            <div class="title">消息中心</div>
            <div class="service-img" @click="$router.push('/base-service')">
                <img class="ser" src="~images/user_service.png" />
            </div>
        </div>
        <div class="content">
            <div v-if="isblank == true">
                <div class="list" v-for="(item, index) in list" :key="index">
                    <div class="top">
                        <div class="title">
                            <span>
                                <img :src="logo" v-if="item.appid == 0" />
                                <img :src="game_logo_url" v-else />
                            </span>
                            <span>{{item.title}}</span>
                        </div>
                        <div class="time">{{getTime(item.create_time)}}</div>
                    </div>
                    <div class="bottom">{{item.desc}}</div>
                </div>
            </div>
            <div class="theblank" v-if="isblank == false">
                <TheBlank />
            </div>
        </div>
    </div>
</template>

<script>
    import moment   from 'moment'
    import TheBlank from '@/components/TheBlank'

    export default {
        name: 'BaseMessage',
        components: {
            TheBlank
        },
        data () {
            return {
                logo: require('images/logo.png'),
                list: [],
                gameLogo: '',
                isblank: null
            }
        },
        computed: {
            getTime () {
                return (time) => {
                    let t1 = moment.unix(time)
                    let t2 = moment(moment(new Date()).format('YYYY-MM-DD HH:mm:ss'))
                    // //计算时间差并转换成标准时间单位
                    let dura = t2.format('x') - t1.format('x')
                    let diffTime = t2.diff(t1, 'minute')
                    if (diffTime >= 43200) {
                        diffTime = Number.parseInt(diffTime / 60 / 24 / 30) + '个月前'
                    } else if (diffTime >= 1440) {
                        diffTime = Number.parseInt(diffTime / 60 / 24) + '天前'
                    } else if (diffTime >= 60) {
                        diffTime = Number.parseInt(diffTime / 60) + '小时前'
                    } else if (diffTime >= 5 ) {
                        diffTime = Number.parseInt(diffTime) + '分钟前'
                    } else {
                        diffTime = '刚刚'
                    }
                    // //计算时间差并转换成指定的时间单位
                    return diffTime
                }
            }
        },
        methods: {
            // 获取消息列表
            messageList () {
                let accountData = JSON.parse(sessionStorage.getItem('accountData'))
                let options = {
                    uid: accountData.uid,
                    appid: accountData.appid,
                    channel: accountData.channel
                };
                options.sign = this.util.getSign(options, accountData.appkey)
                this.$axios.post('http://sdk.gameschain.pro/index.php?g=api&m=message&a=getMessageList', this.$qs.stringify(options)).then(res => {
                    if (res.data.status == 1) {
                        this.list = res.data.data.message_list
                        this.gameLogo = res.data.data.game_logo_url
                        this.isblank = this.list.length > 0 ? true : false
                        sessionStorage.setItem('setMessage', JSON.stringify(res.data.data))
                    }
                })
            }
        },
        created () {
            if (sessionStorage.getItem('setMessage')) {
                let setMessage = JSON.parse(sessionStorage.getItem('setMessage'))
                this.list = setMessage.message_list
                this.gameLogo = setMessage.game_logo_url
                this.isblank = this.list.length > 0 ? true : false
            } else {
                this.messageList()
            }
        }
    }
</script>

<style lang="scss" scoped>
    $color: #FF6C22; // 主体颜色
    // 横屏css
    .base-message {
        width: 1080px;
        height: 100%;
        background: rgba(0, 0, 0, 0.8);
        display: flex;
        flex-direction: column;
        transition: all 0.3s;
        .header {
            height: 132px;
            background: rgba($color, 0.8);
            display: flex;
            align-items: center;
            justify-content: center;
            position: relative;
            .title {
                font-size: 51px;
                text-align: center;
            }
            .service-img {
                width: 192px;
                height: 132px;
                position: absolute;
                right: 0;
                display: flex;
                align-items: center;
                justify-content: center;
                .ser {
                    width: 72px;
                    height: 72px;
                }
            }
        }
        .content {
            flex: 1;
            overflow-y: scroll;
            padding: 60px;
            position: relative;
            .list {
                display: flex;
                flex-direction: column;
                border-radius: 18px;
                background: rgba(255, 255, 255, 0.2);
                padding: 30px 45px 25px;
                margin-bottom: 30px;
                overflow: hidden;
                .top {
                    display: flex;
                    justify-content: space-between;
                    align-items: center;
                }
                .top .title {
                    font-size: 39px;
                    display: flex;
                    align-items: center;
                }
                .top .title img {
                    width: 60px;
                    height: 60px;
                    border-radius: 15px;
                    background: rgba(255, 255, 255, 0.5);
                    margin-right: 15px;
                }
                .top .time {
                    font-size: 33px;
                    color: rgba(255, 255, 255, 0.5);
                    display: flex;
                    align-items: center;
                    justify-content: center;
                }
                .bottom {
                    font-size: 42px;
                    margin-top: 20px;
                }
            }
            .list:last-child {
                margin-bottom: 0;
            }
            .theblank {
                position: absolute;
                top: 50%;
                left: 50%;
                transform: translate(-50%, -50%);
            }
        }
    }
    // 竖屏css
    .message-sp {
        width: 100%;
        height: 100%;
        .header {
            height: 240px;
            border-radius: 60px 0 0 0;
            .title {
                font-size: 92px;
            }
            .service-img {
                width: 290px;
                height: 240px;
                .ser {
                    width: 130px;
                    height: 130px;
                }
            }
        }
        .content {
            padding: 90px;
            .list {
                border-radius: 32px;
                padding: 50px 60px 45px;
                margin-bottom: 54px;
                .top .title {
                    font-size: 70px;
                }
                .top .title img {
                    width: 109px;
                    height: 109px;
                    border-radius: 27px;
                    margin-right: 27px;
                }
                .top .time {
                    font-size: 60px;
                }
                .bottom {
                    font-size: 76px;
                    margin-top: 30px;
                }
            }
        }
    }
</style>